import * as Yup from 'yup';
import { TypeOfUser } from '@pharmaplan/common';
import strings from '../../../localization';
import {
  nameRegex,
  onlyNumbersRegex,
  postalCodeRegExp,
} from '../../../helpers/Constants';
import { incorporatedProfessionalValidator } from '../../../helpers/commonValidators';

export const onlyNumbers = Yup.string().matches(
  onlyNumbersRegex,
  strings.formatString(strings.pleaseEnterValidFormat, strings.number.toLowerCase()) as string,
);

const pharmacistBasedValidation = () =>
  onlyNumbers
    .required(strings.requiredField)
    .when('role', {
      is: (values: TypeOfUser) =>
        values !== TypeOfUser.pharmacist,
      then: () =>
        onlyNumbers.nullable(),
    });

const studentBasedValidation = () =>
  onlyNumbers
    .required(strings.requiredField)
    .when('role', {
      is: (values: TypeOfUser) =>
        values === TypeOfUser.student,
      then: () =>
        onlyNumbers.nullable(),
    });

const professionalValidation = () =>
  ({
    licenseNumber: onlyNumbers.required(strings.requiredField),
    pharmacistCapacityId: Yup.string().required(strings.requiredField),
    graduationYear: onlyNumbers.required(strings.requiredField),
    otherLanguages: Yup.string(),
  });

const selfProfessionalValidation = () =>
  ({
    licenseNumber: pharmacistBasedValidation(),
    graduationYear: studentBasedValidation(),
    pharmacistCapacityId: Yup.string().required(strings.requiredField),
  });

export const GeneralValidator = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    lastName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    preferdLanguage: Yup.string().required(strings.requiredField),
    selectedContactPreferences: Yup.array().min(1, strings.pleaseSelectOne),
  });

export const ProfessionalValidator = () =>
  Yup.object().shape(professionalValidation());

export const SoftwareValidator = () =>
  Yup.object().shape({});
export const ContactValidator = () =>
  Yup.object().shape({
    province: Yup.string().required(strings.requiredField),
    address: Yup.string().required(strings.requiredField),
    city: Yup.string().required(strings.requiredField),
    postalCode: Yup.string()
      .required(strings.requiredField)
      .matches(postalCodeRegExp, strings.postalCodeValidation),
    phone: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(
          strings.phoneValidation,
          strings.homePhone,
        ) as string,
      ),
    mobile: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      ),
  });

export const professionalCorporatedValidator = () =>
  Yup.object().shape({
    ...selfProfessionalValidation(),
    ...incorporatedProfessionalValidator(),
  });
